import { render, staticRenderFns } from "./OfferLineFooterItem.vue?vue&type=template&id=0024821d"
import script from "./OfferLineFooterItem.vue?vue&type=script&lang=js"
export * from "./OfferLineFooterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports